import { Box, Container } from "@mui/material";
import React from "react";

import Banner from "../../components/common/Banner";
import HomeProductSection from "../../components/frontend/home/HomeProductSection";
import TopBrands from "../../components/frontend/home/TopBrands";
import TopCategories from "../../components/frontend/home/TopCategories";
import PublicReviewsSection from "../../components/frontend/reviews/PublicReviewsSection";
import { generatePageMetaTags, useMetaTags } from "../../hooks/useMetaTags";

const Home: React.FC = () => {
  // Set page-specific meta tags
  useMetaTags(generatePageMetaTags.home());

  return (
    <Box
      sx={(theme) => ({
        // Undo the PageLayout horizontal padding so we can align with the nav gutters
        width: {
          xs: `calc(100% + ${theme.spacing(4)})`,
          sm: `calc(100% + ${theme.spacing(5)})`,
          md: `calc(100% + ${theme.spacing(6)})`,
          lg: `calc(100% + ${theme.spacing(6)})`,
        },
        ml: { xs: -2, sm: -2.5, md: -3, lg: -3 },
        mr: { xs: -2, sm: -2.5, md: -3, lg: -3 },
      })}
    >
      <Container maxWidth="xl" disableGutters sx={{ px: 2 }}>
        <Banner />

        <TopCategories />

        <TopBrands />

        <HomeProductSection />

        <PublicReviewsSection />
      </Container>
    </Box>
  );
};

export default Home;
